// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__Xoik1","head":"Table_head__1kfRN","col":"Table_col__gM4Q4"};